import React from 'react';
import { Button } from '../shared/Button';
import { CheckIcon, XIcon } from 'lucide-react';
export const CoachingTiersSection = () => {
  const features = [{
    name: 'Resume Support',
    silver: 'Templates',
    gold: 'One Rewrite',
    platinum: 'Multi-Version Optimization'
  }, {
    name: '1:1 Coaching',
    silver: '❌',
    gold: 'Monthly',
    platinum: '2–3x/Week'
  }, {
    name: 'Interview Story Work',
    silver: 'DIY',
    gold: '1 Story Script',
    platinum: '6–10 Scripted & Reviewed Stories'
  }, {
    name: 'Technical Access',
    silver: 'Group Sessions',
    gold: 'Group + Some 1:1',
    platinum: 'Full Group + 1:1 Add-On Available'
  }, {
    name: 'Salary Negotiation',
    silver: 'Workshop',
    gold: 'One Call',
    platinum: 'Full Comp Strategy & Scripts'
  }, {
    name: 'Text/Slack Support',
    silver: '❌',
    gold: '❌',
    platinum: '✅'
  }, {
    name: 'Pre-Interview Coaching',
    silver: '❌',
    gold: '❌',
    platinum: '✅'
  }, {
    name: 'Coach Access',
    silver: 'Shared',
    gold: 'Shared',
    platinum: 'David or Michelle + Technical Team'
  }, {
    name: 'AI Auto-apply',
    silver: '200/week',
    gold: '200/week',
    platinum: '400/week'
  }];
  const renderFeatureValue = (value: string) => {
    if (value === '✅') {
      return <CheckIcon className="w-5 h-5 text-[#FFC501] mx-auto" data-id="element-104" />;
    }
    if (value === '❌') {
      return <XIcon className="w-5 h-5 text-gray-500 mx-auto" data-id="element-105" />;
    }
    return <span className="text-white/80 text-sm sm:text-base" data-id="element-106">{value}</span>;
  };
  return <section id="pricing" className="w-full bg-[#231232] py-24 scroll-mt-24" data-id="element-107">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-108">
        <div className="text-center mb-16" data-id="element-109">
          <span className="inline-block px-4 py-1.5 bg-[#FFC501]/10 text-[#FFC501] rounded-full text-sm font-medium mb-4" data-id="element-110">
            PRICING OPTIONS
          </span>
          <h2 className="text-4xl sm:text-5xl font-outfit font-bold mb-6 text-white" data-id="element-111">
            Choose Your Path to Success
          </h2>
          <div className="h-1 w-24 bg-gradient-to-r from-[#FFC501] to-[#DF4425] mx-auto rounded-full mb-6" data-id="element-112"></div>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-113">
            Three tiers of support designed to match your career goals and
            commitment level
          </p>
        </div>
        {/* Mobile View */}
        <div className="md:hidden space-y-8" data-id="element-114">
          {['Silver', 'Gold', 'Platinum'].map(tier => <div key={tier} className={`relative backdrop-blur-xl rounded-2xl border p-8 ${tier === 'Platinum' ? 'bg-gradient-to-br from-[#231232] via-[#1a0d24] to-[#231232] border-[#FFC501]/20 shadow-lg' : 'bg-white/5 border-white/10'}`} data-id="element-115">
              {tier === 'Platinum' && <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-[#FFC501] to-[#DF4425] text-[#231232] px-4 py-1 rounded-full text-sm font-bold shadow-lg" data-id="element-116">
                  Recommended
                </div>}
              <div className="mb-6 text-center" data-id="element-117">
                <h3 className="text-2xl font-outfit font-bold text-white mb-2" data-id="element-118">
                  {tier}
                </h3>
              </div>
              <div className="space-y-4" data-id="element-119">
                {features.map(feature => <div key={feature.name} className="flex items-center justify-between py-3 border-b border-white/5 last:border-0" data-id="element-120">
                    <span className="text-white/90 text-sm" data-id="element-121">
                      {feature.name}
                    </span>
                    <div className="ml-4" data-id="element-122">
                      {renderFeatureValue(feature[tier.toLowerCase() as 'silver' | 'gold' | 'platinum'])}
                    </div>
                  </div>)}
              </div>
              <div className="mt-8" data-id="element-123">
                <Button variant={tier === 'Platinum' ? 'gradient-primary' : 'secondary'} size="lg" className="w-full" href={tier === 'Platinum' ? 'https://meetings.hubspot.com/logan-robilliard/platinum' : `https://meetings.hubspot.com/logan-robilliard/platinum`} external data-id="element-124">
                  {tier === 'Platinum' ? 'Apply Now' : 'Learn More'}
                </Button>
              </div>
            </div>)}
        </div>
        {/* Desktop View - update table styling */}
        <div className="hidden md:block relative backdrop-blur-xl bg-white/5 rounded-2xl border border-white/10 p-8 overflow-visible shadow-xl" data-id="element-125">
          <div className="min-w-[800px] relative" data-id="element-126">
            {/* Platinum Column Background */}
            <div className="absolute top-0 right-0 w-1/4 h-full bg-gradient-to-br from-white/[0.07] via-white/[0.03] to-transparent rounded-r-xl" data-id="element-127" />
            <table className="w-full relative" data-id="element-128">
              <thead data-id="element-129">
                <tr data-id="element-130">
                  <th className="py-8 px-4 text-left text-gray-400 font-normal w-1/4" data-id="element-131">
                    Feature
                  </th>
                  {['Silver', 'Gold', 'Platinum'].map(tier => <th key={tier} className="py-8 px-4 text-center relative w-1/4" data-id="element-132">
                      {tier === 'Platinum' && <div className="absolute -top-12 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-[#FFC501] to-[#DF4425] text-[#231232] px-6 py-2 rounded-full text-sm font-bold shadow-lg whitespace-nowrap" data-id="element-133">
                          Recommended
                        </div>}
                      <div className="text-2xl font-outfit font-bold text-white mb-2" data-id="element-134">
                        {tier}
                      </div>
                      <div className="text-lg font-outfit text-white/70 mb-1" data-id="element-135">
                        {tier === 'Platinum' ? 'Premium' : tier === 'Gold' ? 'Standard' : 'Basic'}
                      </div>
                    </th>)}
                </tr>
              </thead>
              <tbody data-id="element-136">
                {features.map(feature => <tr key={feature.name} className="border-t border-white/5" data-id="element-137">
                    <td className="py-4 px-4 text-white/90 font-medium" data-id="element-138">
                      {feature.name}
                    </td>
                    <td className="py-4 px-4 text-center" data-id="element-139">
                      {renderFeatureValue(feature.silver)}
                    </td>
                    <td className="py-4 px-4 text-center" data-id="element-140">
                      {renderFeatureValue(feature.gold)}
                    </td>
                    <td className="py-4 px-4 text-center" data-id="element-141">
                      {renderFeatureValue(feature.platinum)}
                    </td>
                  </tr>)}
                <tr className="border-t border-white/5" data-id="element-142">
                  <td className="py-8 px-4" data-id="element-143"></td>
                  <td className="py-8 px-4 text-center" data-id="element-144">
                    <Button variant="secondary" size="lg" className="w-full" href="/start" data-id="element-145">
                      Learn More
                    </Button>
                  </td>
                  <td className="py-8 px-4 text-center" data-id="element-146">
                    <Button variant="secondary" size="lg" className="w-full" href="/start" data-id="element-147">
                      Learn More
                    </Button>
                  </td>
                  <td className="py-8 px-4 text-center" data-id="element-148">
                    <Button variant="gradient-primary" size="lg" className="w-full" href="/start" data-id="element-149">
                      Apply Now
                    </Button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        {/* ROI Calculator Banner */}
        <div className="mt-16 relative backdrop-blur-xl bg-gradient-to-br from-[#6805DA]/10 via-[#4B0599]/5 to-transparent rounded-2xl p-8 border border-[#6805DA]/20 text-center" data-id="element-150">
          <h3 className="text-2xl font-outfit font-bold text-white mb-3" data-id="element-151">
            Calculate Your Investment ROI
          </h3>
          <p className="text-white/80 mb-6 max-w-2xl mx-auto" data-id="element-152">
            Our clients see an average return of 5-10x on their investment
            through increased compensation. Use our calculator to see what your
            potential return could be.
          </p>
          <Button variant="outline" size="lg" className="inline-flex items-center gap-2" href="/start" data-id="element-153">
            Schedule an ROI Consultation
          </Button>
        </div>
      </div>
    </section>;
};